<template>
  <div class="emd-creditcard-container _justify_baseline">
    <div class="emd-creditcard" :class="{'emd-creditcard-flipped': flipped}">
      <div class="emd-creditcard-front">
        <div id="ccsingle"></div>
        <svg version="1.1" id="creditcard-front" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px" y="0px" viewBox="0 0 750 471" style="enable-background:new 0 0 750 471;" xml:space="preserve">
            <g id="Front">
                <g id="creditcard-background">
                    <g id="Page-1_1_">
                        <g id="amex_1_">
                            <path id="Rectangle-1_1_" class="lightcolor grey" d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40
                        C0,17.9,17.9,0,40,0z" />
                        </g>
                    </g>
                    <path class="darkcolor greydark"
                        d="M750,431V193.2c-217.6-57.5-556.4-13.5-750,24.9V431c0,22.1,17.9,40,40,40h670C732.1,471,750,453.1,750,431z" />
                </g>
                <text transform="matrix(1 0 0 1 60.106 295.0121)" id="creditcard-number" class="_fill-500 _font-weight-havy _font-size-xxlarge fs-hide">{{ cardNumber }}</text>
                <text transform="matrix(1 0 0 1 54.1064 428.1723)" id="creditcard-name" class="_fill-500 _font-weight-havy _font-size-medium eu-uppercase">{{ cardName }}</text>
                <text transform="matrix(1 0 0 1 54.1074 389.8793)" class="_fill-primary _font-opacity _font-weight-medium _font-size-small">Nome como está no cartão</text>
                <text transform="matrix(1 0 0 1 65.1054 241.5)" class="_fill-primary _font-size-small">Número do cartão</text>
                <g>
                  <text transform="matrix(1 0 0 1 574.4219 433.8095)" id="creditcard-exp" class="_fill-500 _font-weight-havy _font-size-medium fs-hide">{{ cardMonth }}/{{ cardYear }}</text>
                  <text transform="matrix(1 0 0 1 479.3848 417.0097)" class="_fill-primary _font-size-tiny">Data de</text>
                  <text transform="matrix(1 0 0 1 479.3848 435.6762)" class="_fill-primary _font-size-tiny">Validade</text>
                </g>
                <g id="creditcard-chip">
                  <g>
                      <path class="_fill-000" d="M168.1,143.6H82.9c-10.2,0-18.5-8.3-18.5-18.5V74.9c0-10.2,8.3-18.5,18.5-18.5h85.3
                  c10.2,0,18.5,8.3,18.5,18.5v50.2C186.6,135.3,178.3,143.6,168.1,143.6z" />
                  </g>
                  <g>
                    <g>
                        <rect x="82" y="70" class="_fill-primary" width="1.5" height="60" />
                    </g>
                    <g>
                        <rect x="167.4" y="70" class="_fill-primary" width="1.5" height="60" />
                    </g>
                    <g>
                        <path class="_fill-primary" d="M125.5,130.8c-10.2,0-18.5-8.3-18.5-18.5c0-4.6,1.7-8.9,4.7-12.3c-3-3.4-4.7-7.7-4.7-12.3
                    c0-10.2,8.3-18.5,18.5-18.5s18.5,8.3,18.5,18.5c0,4.6-1.7,8.9-4.7,12.3c3,3.4,4.7,7.7,4.7,12.3
                    C143.9,122.5,135.7,130.8,125.5,130.8z M125.5,70.8c-9.3,0-16.9,7.6-16.9,16.9c0,4.4,1.7,8.6,4.8,11.8l0.5,0.5l-0.5,0.5
                    c-3.1,3.2-4.8,7.4-4.8,11.8c0,9.3,7.6,16.9,16.9,16.9s16.9-7.6,16.9-16.9c0-4.4-1.7-8.6-4.8-11.8l-0.5-0.5l0.5-0.5
                    c3.1-3.2,4.8-7.4,4.8-11.8C142.4,78.4,134.8,70.8,125.5,70.8z" />
                    </g>
                    <g>
                        <rect x="82.8" y="82.1" class="_fill-primary" width="25.8" height="1.5" />
                    </g>
                    <g>
                        <rect x="82.8" y="117.9" class="_fill-primary" width="26.1" height="1.5" />
                    </g>
                    <g>
                        <rect x="142.4" y="82.1" class="_fill-primary" width="25.8" height="1.5" />
                    </g>
                    <g>
                        <rect x="142" y="117.9" class="_fill-primary" width="26.2" height="1.5" />
                    </g>
                  </g>
                </g>
            </g>
        </svg>
      </div>
      <div class="emd-creditcard-back">
        <svg version="1.1" id="creditcard-back" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px" y="0px" viewBox="0 0 750 471" style="enable-background:new 0 0 750 471;" xml:space="preserve">
          <g id="Back">
              <g>
                  <g>
                      <path d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40
                  C0,17.9,17.9,0,40,0z" />
                  </g>
              </g>
              <rect y="61.6" class="_fill-400" width="750" height="78" />
              <g>
                <path class="_fill-000" d="M701.1,249.1H48.9c-3.3,0-6-2.7-6-6v-52.5c0-3.3,2.7-6,6-6h652.1c3.3,0,6,2.7,6,6v52.5 C707.1,246.4,704.4,249.1,701.1,249.1z"></path>
                <rect x="42.9" y="198.6" class="_fill-400" width="664.1" height="10.5" />
                <rect x="42.9" y="224.5" class="_fill-500" width="664.1" height="10.5" />
                <path class="_fill-000"
                    d="M701.1,184.6H618h-8h-9v64.5h10h8h83.1c3.3,0,6-2.7,6-6v-52.5C707.1,187.3,704.4,184.6,701.1,184.6z" />
              </g>
              <text transform="matrix(1 0 0 1 621.999 227.2734)" class="_fill-primary _font-size-medium _font-opacity fs-hide">{{ card.cvv }}</text>
              <g class="st8">
                <text transform="matrix(1 0 0 1 616.083, 286.088)" class="_fill-500 _font-size-large _font-size-medium _font-weight-medium">CVV</text>
              </g>
            </g>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>

export class CreditCard {
  constructor (number, holderName, expMonth, expYear, cvv) {
    this.number = number
    this.holder_name = holderName
    this.exp_month = expMonth
    this.exp_year = expYear
    this.cvv = cvv
  }
}

export default {
  name: 'CreditCard',
  components: {},
  props: {
    card: new CreditCard(),
    flipped: {
      type: Boolean,
      default: false,
      required: false,
      validator: (value) => {
        return [true, false].includes(value)
      }
    }
  },
  computed: {
    cardNumber () {
      if (!this.card.number) { return '0000 0000 0000 0000' }
      const length = this.card.number.length > 16 ? 19 : 16
      const unformattedValue = this.card.number.toString().replace(/\D/g, '')
      const leadingZerosValue = `${unformattedValue}${'0'.repeat(length)}`.slice(0, -this.card.number.length)
      if (length === 16) {
        return leadingZerosValue.replace(/^(\d{4})(\d{4})(\d{4})(\d{4})$/, '$1 $2 $3 $4')
      }
      return leadingZerosValue.replace(/^(\d{4})(\d{4})(\d{4})(\d{4})(\d{3})$/, '$1 $2 $3 $4 $5')
    },
    cardName () {
      return this.card.holder_name || 'Nome sobrenome'
    },
    cardMonth () {
      return this.formattDate(this.card.exp_month) || 'DD'
    },
    cardYear () {
      return this.formattDate(this.card.exp_year) || 'AA'
    }
  },
  methods: {
    formattDate (number) {
      return number < 10 ? `0${number}` : number
    }
  }
}
</script>
